export const capitalizeFirstLetter = (str, locale = "en") => {
  if (!str) return "";
  return str.charAt(0).toLocaleUpperCase(locale) + str.slice(1).toLocaleLowerCase(locale);
};
